import { useState, useEffect } from 'react';
import { AlertCircle, X } from 'lucide-react';

const AgeVerification = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Check if user has already verified their age
    const ageVerified = localStorage.getItem('ageVerified');
    if (!ageVerified) {
      setShowPopup(true);
    }
  }, []);

  const handleConfirm = () => {
    localStorage.setItem('ageVerified', 'true');
    setShowPopup(false);
  };

  const handleDecline = () => {
    // Redirect to responsible gaming page or show message
    window.location.href = '/responsible-gaming';
  };

  if (!showPopup) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-8 relative">
        <div className="flex items-center space-x-3 mb-6">
          <AlertCircle className="text-yellow-accent" size={32} />
          <h2 className="text-2xl font-bold text-gray-dark">Age Verification Required</h2>
        </div>
        
        <div className="mb-6">
          <p className="text-gray-light leading-relaxed mb-4">
            This website is intended for users aged 18 and over only. Online gambling is 
            restricted to individuals who have reached the legal age of majority in their 
            jurisdiction.
          </p>
          <p className="text-gray-light leading-relaxed">
            By clicking "I am 18 or older", you confirm that you are of legal age to gamble 
            in your jurisdiction and that online gambling is legal where you are located.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4">
          <button
            onClick={handleConfirm}
            className="flex-1 bg-yellow-accent text-gray-dark py-3 px-6 rounded-lg font-bold hover:bg-yellow-light transition-colors"
          >
            I am 18 or older
          </button>
          <button
            onClick={handleDecline}
            className="flex-1 border-2 border-gray-300 text-gray-dark py-3 px-6 rounded-lg font-bold hover:bg-gray-50 transition-colors"
          >
            I am under 18
          </button>
        </div>

        <div className="mt-6 pt-6 border-t border-gray-200">
          <p className="text-xs text-gray-light text-center">
            Please gamble responsibly. For support with problem gambling, visit{' '}
            <a 
              href="https://www.begambleaware.org" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-yellow-accent hover:underline"
            >
              BeGambleAware.org
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AgeVerification;

